import {ReactNode, useState} from "react";
import {Slot} from "../../data/Slot";
import {DataView} from "primereact/dataview";
import SlotComponent from "./SlotComponent";
import {Checkbox} from "primereact/checkbox";

const nowMidnight = new Date();
nowMidnight.setHours(0);
nowMidnight.setMinutes(0);
nowMidnight.setSeconds(0);

const end = new Date();
end.setDate(end.getDate() + 90);
end.setHours(0);
end.setMinutes(0);
end.setSeconds(0);

function SlotListCompontent({
                                slots,
                                onSlotChanged,
                                onSlotDeleted,
                            }: {
    slots: Slot[];
    onSlotChanged(slot: Slot): void;
    onSlotDeleted(slot: Slot): void;
}) {
    const [hidePastSlots, setHidePastSlots] = useState<boolean>(true);

    function itemTemplate(item: Slot): ReactNode {
        return (
            <SlotComponent
                onSlotChanged={onSlotChanged}
                onSlotDeleted={onSlotDeleted}
                slot={item}
            />
        );
    }

    const listTemplate = (items: Slot[], layout?: string) => {
        return (
            <div className="grid grid-nogutter gap-5 flex-column">
                {items.map((item, index) => itemTemplate(item))}
            </div>
        );
    };

    const filterSlots = (slots: Slot[]): Slot[] => {
        if (!hidePastSlots) {
            return slots;
        }

        const now = new Date();
        now.setHours(0);
        now.setMinutes(0);
        now.setSeconds(0);

        return slots.filter((slot) => {
            const slotStartTime = new Date(slot.startDateTime);
            return slotStartTime >= now;
        });
    };

    return (
        <div className="flex flex-column gap-5">
            <div className="flex align-items-center gap-2 mt-2">
                <Checkbox
                    inputId="hidePastSlots"
                    checked={hidePastSlots}
                    onChange={(e) => setHidePastSlots(e.checked || false)}
                />
                <label htmlFor="hidePastSlots">Vergangene Termine ausblenden</label>
            </div>
            <DataView
                paginator
                rows={5}
                value={filterSlots(slots) || undefined}
                listTemplate={listTemplate}
            />
        </div>
    );
}

export default SlotListCompontent;
